import { apiGet, apiPut } from '@/api/client';
import type { User } from '@/api/types';

/** The caller's own record, private fields included (§ `/users/{userId}`,
 * `me` addresses the caller). */
export function getMyProfile(): Promise<User> {
  return apiGet('/users/{userId}', { params: { userId: 'me' } });
}

/**
 * `PUT /users/{userId}` writes every field it is sent as `null` rather than
 * leaving it alone — always send the full editable record, per the
 * endpoint's own contract (see `UserEditPage`, the pre-WP-11 version of this
 * form, for the same rule).
 */
export interface ProfileUpdate {
  nickname: string | null;
  preferred_language: string | null;
  region: string | null;
  gender: number | null;
  birthdate: string | null;
  height: number | null;
  weight: number | null;
}

export function updateMyProfile(body: ProfileUpdate): Promise<{ success?: boolean } | undefined> {
  return apiPut('/users/{userId}', { params: { userId: 'me' }, body });
}

/**
 * The IANA timezone the statistics rollup cuts this user's days on (§
 * Statistiek-elementen, `PUT /statistics/timezone`). `null` falls back to
 * the deployment default. Defaults to the caller when `userId` is omitted.
 */
export function setStatisticsTimezone(
  timezone: string | null,
): Promise<{ timezone?: string | null; requeued_days?: number } | undefined> {
  return apiPut('/statistics/timezone', { body: { timezone } });
}
